<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20" id="code-detail">
      <loading v-if="working" class="mt10 text-center" :text="'Please wait'|translate"></loading>

      <div v-if="message" class="alert alert-warning" role="alert">{{message|translate}}</div>
      <div class="row" v-if="user">
        <div class="col-md-8">
          <h3>{{'Activity List'|translate}}</h3>
          <p v-if="list_histories.length == 0" class="alert alert-info">{{'No history'|translate}}</p>
          <ul class="list-ic vertical">
            <li v-for="(item,index) in list_histories" :key="item.id">
              <span>{{index + 1}}</span>
              <div class="content">
                <span>{{ item.start_date | moment("DD/MM/YYYY") }}</span>
                - {{item.action_name}}
                <small
                  v-if="item.description"
                >({{item.description}})</small>
                <!-- <list-history-photo :item="item" ></list-history-photo> -->
                <div class="item" v-if="item.images">
                  <!-- <label>{{'Attached Photos'|translate}}</label> -->
                  <div class="gallery">
                    <a
                      class="wrap"
                      v-for="(photo, photoIndex) in item.images"
                      :key="photoIndex"
                      @click="clickPhoto(item,photoIndex)"
                    >
                      <img class="thumb" :src="photo.url_thumb" />
                    </a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <div class="panel panel-info">
            <div class="panel-heading">{{'Harvest Info'|translate}}</div>
            <div class="panel-body">
              <p>
                {{'Product'|translate}}:
                <span>{{ harvest_item.product_name }}</span>
              </p>
              <p>
                {{'Date'|translate}}:
                <span>{{ harvest_item.start_date | moment("DD/MM/YYYY") }}</span>
              </p>
              <p>
                {{'Note'|translate}}:
                <span>{{ harvest_item.note }}</span>
              </p>
              <p>
                {{'Serial'|translate}} :
                <span>{{ serial_item.seri_number }}</span>
              </p>
              <p>
                {{'Code'|translate}} :
                <span>{{ serial_item.unique_code }}</span>
              </p>
              <p>
                {{'QR Code'|translate}} :
                <br />
                <qrcode :value="current_link" tag="img" :options="{ width: 80 }"></qrcode>
              </p>
            </div>
          </div>
          <div class="panel panel-info">
            <div class="panel-heading">{{'Garden Info'|translate}}</div>
            <div class="panel-body">
              <p>
                {{'Owner'|translate}}:
                <router-link :to="{ name: 'Profile', params: { profileId: user.id }}">{{user.name}}</router-link>
              </p>
              <p>
                {{'Description'|translate}}:
                <span>{{user.description}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end pd20 -->
    <gallery v-if="photos" :images="photos" :index="index" @close="index = null"></gallery>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";

import gallery from "vue-gallery";
export default {
  name: "SearchCode",
  components: {
    MyHeader,
    Loading,
    gallery
  },
  data() {
    return {
      working: false,
      unique_code: null,
      user: null,
      list_histories: null,
      harvest_item: null,
      serial_item: null,
      current_link: location.href,
      message: null,
      photos: [],
      index: null
    };
  },
  methods: {
    clickPhoto(item, photoIndex) {
      this.photos = item.images.map(item => {
        return item.url_medium;
      });
      this.index = photoIndex;
    }
  },

  mounted() {
    this.unique_code = this.$route.params.unique_code;
    this.working = true;
    Utils.request(this, true)
      .get(`/searchCode/`, { params: { unique_code: this.unique_code } })
      .then(response => {
        this.working = false;
        if (response.data.status != "ok") {
          return (this.message = response.data.data);
        }
        let data = response.data.data;
        this.user = data.user;
        
        if (!data.harvest_item){
          // console.log('data.harvest_item',data.harvest_item);
          // no harvest item
          this.$router.push({ name: "Profile", params: {profileId:this.user.id} });
          return;
        }

        this.list_histories = data.list_histories.list;
        this.list_histories = this.list_histories.map(item => {
          let temp1 = new Date(parseInt(item.start_time) * 1000);
          item.start_date = this.$moment(temp1);
          return item;
        });
        this.harvest_item = data.harvest_item;
        let temp = new Date(parseInt(this.harvest_item.start_time) * 1000);
        this.harvest_item.start_date = this.$moment(temp);
        this.serial_item = data.serial_item;
        this.serial_item.seri_number = Utils.serialFormat(
          this.serial_item.seri_number
        );
        
      })
      .catch(error => {});
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Tracking/SearchCode.vue